import { render, staticRenderFns } from "./RecycleBinDialog.vue?vue&type=template&id=0fe02b37&scoped=true"
import script from "./RecycleBinDialog.vue?vue&type=script&lang=js"
export * from "./RecycleBinDialog.vue?vue&type=script&lang=js"
import style0 from "./RecycleBinDialog.vue?vue&type=style&index=0&id=0fe02b37&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe02b37",
  null
  
)

export default component.exports